import React from "react";
import img_about_us from "../../assets/About-us_img.png";
import service3 from "../../assets/SERVICE_BG_3.png";
import "./AboutUs.css";

function AboutUs() {
  return (
    <div>
      <div className="content-header-about-us">
        <div className="header-about-us">
          <img alt="" src={img_about_us} className="img-about-us" />
        </div>
      </div>
      <div className="detail-about-us">
        <div className="head-detail-about-us">
          <div className="text-head-detail-about-us">
            <div className="text-1-head-detail-about-us">XTEN TECHNOLOGY</div>
            <div className="text-2-head-detail-about-us">
              Qorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu
              turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus
              nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum
              tellus elit sed risus. Maecenas eget condimentum velit, sit amet
              feugiat lectus. Class aptent taciti sociosqu ad litora torquent
              per conubia nostra.
            </div>
            <div className="text-2-head-detail-about-us">
              Qorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu
              turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus
              nec fringilla accumsan, risus sem sollicitudin lacus.
            </div>
          </div>
          <div>
            <img
              alt=""
              src={service3}
              className="example-img"
            />
          </div>
        </div>
        <div className="head-detail-about-us">
          <div className="box-detail-about-us">
            <div className="box-head-detail-about-us">Consult</div>
            <div className="box-sub-detail-about-us">
              Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
              vulputate libero et velit interdum, ac aliquet odio mattis. Class
              aptent taciti sociosqu ad litora torquent per conubia nostra, per
              inceptos himenaeos.
            </div>
          </div>
          <div className="box-detail-about-us">
            <div className="box-head-detail-about-us">Survey</div>
            <div className="box-sub-detail-about-us">
              Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
              vulputate libero et velit interdum, ac aliquet odio mattis. Class
              aptent taciti sociosqu ad litora torquent per conubia nostra, per
              inceptos himenaeos.
            </div>
          </div>
          <div className="box-detail-about-us">
            <div className="box-head-detail-about-us">Prototype Design</div>
            <div className="box-sub-detail-about-us">
              Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
              vulputate libero et velit interdum, ac aliquet odio mattis. Class
              aptent taciti sociosqu ad litora torquent per conubia nostra, per
              inceptos himenaeos.
            </div>
          </div>
        </div>
      </div>
      <div className="service-box">
        <div className="text-header-service-box">Content</div>
        <div className="text-sub-service-box">
          Porem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
          vulputate libero et velit interdum, ac aliquet odio mattis.
        </div>
        <div
          className="img-service-box"
        >
          <div className="img-content-service-box">
            <div className="text-header-service-box" style={{ color: "#fff" }}>
              Content
            </div>
            <div className="text-sub-service-box" style={{ color: "#fff" }}>
              Porem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu
              turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus
              nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum
              tellus elit sed risus. Maecenas eget condimentum velit, sit amet
              feugiat lectus.{" "}
            </div>
          </div>
        </div>
      </div>
      <div className="about-us-blog">
        <div style={{fontSize: '44px',fontWeight: '700'}}>XTEN</div>
        <div className="about-us-blog-content">
          <div className="about-us-blog-content-detail">
            <div>
             Qorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Praesent auctor purus luctus enim egestas, ac scelerisque ante pulvinar.
            </div>
            <div>
            Qorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Praesent auctor purus luctus enim egestas, ac scelerisque ante pulvinar.
            </div>
          </div>
          <div className="about-us-blog-content-detail">
            <div>
            Qorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Praesent auctor purus luctus enim egestas, ac scelerisque ante pulvinar.
            </div>
            <div>
            Qorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Praesent auctor purus luctus enim egestas, ac scelerisque ante pulvinar.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 

export default AboutUs;
